import CaseFirstView from 'components/cases/common/CasesFirstView/'
import OverView from 'components/cases/common/Overview/'
import Interview from 'components/cases/mss/Interview/'
import CaseStudy from 'components/home/CaseStudy'
import {
  firstViewItem,
  overviewTitle,
  overviewItem,
  issueSolutionItems,
  caseCTAItem,
  caseDownloadCTAItem,
} from './MssItems'
import CaseCTA from 'components/cases/common/CaseCTA'
import CaseDownloadCTA from 'components/cases/common/CaseDownloadCTA'
import FooterCTA from 'components/common/FooterCTA'

const Mss = (): JSX.Element => {
  return (
    <section>
      <CaseFirstView firstViewItem={firstViewItem} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <CaseDownloadCTA {...caseDownloadCTAItem} />
      <FooterCTA />
      <CaseStudy enTitle="Case study" jaTitle="事例" tagType="h2" />
    </section>
  )
}

export default Mss
